"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var VolumeMute = function VolumeMute(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 140 140",
    width: "140",
    height: "140"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(5.833333333333333,0,0,5.833333333333333,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.422,4.658a1.5,1.5,0,0,0-1.571.142L5.251,9h-3a1.5,1.5,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h3l6.6,4.2a1.5,1.5,0,0,0,2.4-1.2V6A1.5,1.5,0,0,0,13.422,4.658Z",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.251 9L5.251 15",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.249 9.375L17.999 14.625",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.999 9.375L23.249 14.625",
    fill: "none",
    stroke: fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  })));
};
VolumeMute.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
VolumeMute.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = VolumeMute;